import {Injectable, NgZone} from '@angular/core';
import {FeedbackDialogComponent} from './feedback-dialog.component';
import {Feedback} from '@backend/modules/@users/models/feedback.model';
import {MatDialog} from '@angular/material/dialog';
import {TorchFeedbackService} from '@backend/modules/@users/services/torch-feedback.service';
import {TorchFilesService} from '@backend/modules/@files/services/torch-files.service';
import {AlertService} from '../../services/alert.service';
import {BehaviorSubject, of} from 'rxjs';
import {catchError, filter, map, switchMap} from 'rxjs/operators';
import {LoggingService} from '../../services/logging.service';

@Injectable({
  providedIn: 'root'
})
export class FeedbackDialogService {

  private dataURL: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(private matDialog: MatDialog,
              private zone: NgZone,
              private feedbackService: TorchFeedbackService,
              private filesService: TorchFilesService,
              private logger: LoggingService,
              private alertService: AlertService) {
    this.feedbackService.currentScreenshot.subscribe(dataURL => this.dataURL.next(dataURL));
  }

  openFeedbackDialog() {
    this.zone.runOutsideAngular(() =>  this.feedbackService.takeScreenshot());

    const feedbackDialog = this.matDialog.open(FeedbackDialogComponent, {
      panelClass: 'feedback-form-dialog',
    });

    let feedback: Feedback;

    return feedbackDialog.afterClosed().pipe(
      switchMap((result: { action: 'cancel' | 'submit'; feedback: Feedback }) => {
        if (!!result && !!result.action && result.action === 'submit') {
          feedback = result.feedback;
          feedback.logs = this.getLogs();

          return this.dataURL.pipe(
            filter(url => !!url),
            switchMap(dataURL => this.filesService.uploadBase64(dataURL, 'image/png', 'feedback-screenshot.png'))
          );
        }
        return of(null);
      }),
      switchMap(uploadResponse => {
        if (!!uploadResponse && !!uploadResponse.file && !!uploadResponse.file.downloadURL) {
          feedback.screenshot = uploadResponse.file.downloadURL;
        } else {
          this.logger.logWarning('UploadResponse did not contain a file', uploadResponse);
        }

        return this.feedbackService.submitFeedbackItem(feedback);
      }),
      map(feedbackResponse => {
        if (!!feedbackResponse && feedbackResponse.id) {
          this.alertService.setCurrentAlert({type: 'info', message: 'Feedback submitted successfully'});
          this.feedbackService.sendUserFeedbackEmail(feedback).pipe(
            catchError(err => of(Object.assign({error: true}, err)))
          ).subscribe(errOrSuccess => {
            if (errOrSuccess.hasOwnProperty('error')) {
              console.error(errOrSuccess);
            }
          });
        }
        return true;
      })
    );
  }

  private getLogs() {
    return this.logger.logMessages.map(msg => {
      if (typeof msg === 'string' || msg instanceof String) {
        return msg;
      } else if (!!msg) {
        return JSON.stringify(msg);
      }
    }).join('\n');
  }
}
